export default __webpack_public_path__ + "static/media/blood.e29ce053.png";